import React, { forwardRef, useContext } from 'react';
import WeatherContext from '../../context/WeatherContext';
import { Box, FormControlLabel, FormControl, MenuItem, Paper, Radio, RadioGroup, Typography } from '@mui/material';
import styles from '../trackfavmenu.module.css';
import weatherStyles from './weather.module.css';
import { ReactComponent as WeatherIcon } from '../../assets/menu/ic_action_umbrella.svg';
import {
    ECMWF_WEATHER_TYPE,
    GFS_WEATHER_TYPE,
    LOCAL_STORAGE_WEATHER_FORECAST_WEEK,
} from '../../manager/WeatherManager';
import ActionItem from '../components/ActionItem';
import { useTranslation } from 'react-i18next';
import { FORECAST_SOURCE_PARAM } from './Weather';
import { useUpdateQueryParam } from '../../util/hooks/menu/useUpdateQueryParam';

export const weatherTypes = {
    GFS: {
        icon: <WeatherIcon className={weatherStyles.icon} />,
        name: 'GFS',
    },
    ECMWF: {
        icon: <WeatherIcon className={weatherStyles.icon} />,
        name: 'ECMWF',
    },
};

const WeatherForecastSourceActions = forwardRef(({ setOpenActions = null }, ref) => {
    const wtx = useContext(WeatherContext);

    const { t } = useTranslation();

    const { updateQueryParam } = useUpdateQueryParam();

    const handleWeatherType = (e) => {
        const selectedType = e.target.value;
        if (selectedType !== null && selectedType !== wtx.weatherType) {
            localStorage.removeItem(LOCAL_STORAGE_WEATHER_FORECAST_WEEK);
            wtx.setWeatherType(selectedType);
            updateQueryParam({ key: FORECAST_SOURCE_PARAM, value: selectedType });
            wtx.setForecastLoading(true);
            if (setOpenActions) {
                setOpenActions(false);
            }
        }
    };

    function setWeatherTypeStyles(type) {
        let res = [];
        if (wtx.weatherType === type) {
            res.push(weatherStyles.controlLabelSelected);
        } else {
            res.push(weatherStyles.controlLabel);
        }
        return res.join(' ');
    }

    return (
        <>
            <Box ref={ref}>
                <Paper id="se-weather-source-actions" className={styles.actions}>
                    <MenuItem className={weatherStyles.titleItem}>
                        <Typography className={weatherStyles.titleText} noWrap>
                            {t('web:weather_source')}
                        </Typography>
                    </MenuItem>
                    <FormControl sx={{ width: '257px' }}>
                        <RadioGroup value={wtx.weatherType} onChange={handleWeatherType}>
                            <FormControlLabel
                                id={'se-GFS'}
                                className={setWeatherTypeStyles(GFS_WEATHER_TYPE)}
                                disableTypography={true}
                                labelPlacement="start"
                                value={GFS_WEATHER_TYPE}
                                control={<Radio className={styles.control} size="small" />}
                                label={<ActionItem item={weatherTypes.GFS} />}
                            />
                            <FormControlLabel
                                id={'se-ECMWF'}
                                className={setWeatherTypeStyles(ECMWF_WEATHER_TYPE)}
                                disableTypography={true}
                                labelPlacement="start"
                                value={ECMWF_WEATHER_TYPE}
                                control={<Radio className={styles.control} size="small" />}
                                label={<ActionItem item={weatherTypes.ECMWF} />}
                            />
                        </RadioGroup>
                    </FormControl>
                </Paper>
            </Box>
        </>
    );
});

WeatherForecastSourceActions.displayName = 'WeatherForecastSourceActions';
export default WeatherForecastSourceActions;
